import { IntlLocaleProvider } from '@hendrx/core/common/components/providers/IntlLocaleProvider';
import { uiI18n } from '@hendrx/core/common/utils/i18nInstances';
import { PropsWithChildren } from 'react';

import { useUiLanguage } from 'shared/utils/useUiLanguage';

export default function TranslationsProvider({ children }: PropsWithChildren) {
  const { uiLanguage } = useUiLanguage();

  return (
    <IntlLocaleProvider locale={uiLanguage} i18nInstance={uiI18n}>
      {children}
    </IntlLocaleProvider>
  );
}
